var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMyDetails = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  "data-name": "my details",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0h24v24H0z",
  "data-name": "Rectangle 5346"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#0e2240",
  d: "M22.988 23.251H1.013v-3.375c0-1.3.746-3.167 4.3-4.628a19.3 19.3 0 0 1 6.685-1.372 19.1 19.1 0 0 1 6.685 1.372c3.556 1.461 4.3 3.323 4.3 4.628Zm-20.475-1.5h18.975v-1.875c0-1.614-2.113-2.723-3.373-3.241A17.8 17.8 0 0 0 12 15.375a17.8 17.8 0 0 0-6.115 1.26c-1.26.518-3.373 1.627-3.373 3.241Zm9.488-9a5.94 5.94 0 0 1-5.869-6 5.94 5.94 0 0 1 5.869-6 5.94 5.94 0 0 1 5.869 6 5.94 5.94 0 0 1-5.869 5.999Zm0-10.5a4.44 4.44 0 0 0-4.369 4.5 4.44 4.44 0 0 0 4.369 4.5 4.44 4.44 0 0 0 4.369-4.5 4.44 4.44 0 0 0-4.369-4.501Z",
  "data-name": "Path 5408"
})));
export { SvgMyDetails as ReactComponent };
export default "/_next/static/images/my_details.svg";